import { Controller } from "stimulus"
export default class extends Controller {
  
  add(e){
    const event = new CustomEvent('addElement', { detail: e.target });
    document.body.dispatchEvent(event)
  } 
}